import { Box } from '@mui/system';
import { CircularProgress } from '@mui/material';

export function ProgressIndicator() {
  return (
    <Box sx={{
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      maxWidth: 400,
    }}>
      <CircularProgress />
    </Box>
  )
}